import { createContext, useContext } from 'react';

export type ConfigColumnSearchContextValue = {
  columnSearchTexts: Record<string, string>;
  setColumnSearchText: (dataKey: string, value: string) => void;
};

export const ConfigColumnSearchContext = createContext<ConfigColumnSearchContextValue | null>(null);

export function useConfigColumnSearch() {
  const ctx = useContext(ConfigColumnSearchContext);
  if (!ctx) {
    throw new Error('useConfigColumnSearch must be used within ConfigColumnSearchContext.Provider');
  }
  return ctx;
}
